import React from 'react';
import { EventsStatsSection as EventsStatsSectionImpl } from './stats.sections';

export default function EventsStatsSection(props) {
    return <EventsStatsSectionImpl {...props} />;
}
